<template>
  <div>
    <van-field
      v-model="password"
      :label="label"
      :name="name"
      :type="type"
      :placeholder="placeholder"
      :rules="rules">
      <template #right-icon>
        <i class="iconfont icon-a-kecheng1" v-if="hidePwd" @click="toggleInputType"></i>
        <i class="iconfont icon-a-kecheng2" v-else @click="toggleInputType"></i>
      </template>
    </van-field>
  </div>
</template>

<script>
  export default {
    props: {
      pwd: {
        type: String,
        default: ''
      },
      label: {
        type: String,
        default: ''
      },
      name: {
        type: String,
        default: ''
      },
      rules: {
        type: Array,
      },
      placeholder: {
        type: String,
        default: '请输入密码'
      }
    },
    data() {
      return {
        password: this.pwd,
        type: 'password',
        hidePwd: true
      }
    },
    methods: {
      toggleInputType() {
        this.hidePwd = !this.hidePwd;
      }
    },
    watch: {
      password(val) {
        this.$emit('update:pwd', val);
      },
      hidePwd(val) {
        if(val) {
          this.type = 'password'
        } else {
          this.type = 'text'
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .iconfont {
    cursor: pointer;
    line-height:45px;
    margin-right:5px;
    color:#666;
    font-size:14px;
    color:#999;
  }
  :deep(.van-field) {
    .van-field__right-icon {
      position:absolute;
      right:0;
    }
  }
</style>
